import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_2 = {
  key: 1,
  id: "player-main"
}

import { loadAllData } from '@/model/Player'
import { useStoreAuth } from '@/store/auth'
import { useStoreGame } from '@/store/game'
import { computed, onBeforeMount, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewMain',
  setup(__props) {

const storeAuth = useStoreAuth()
const storeGame = useStoreGame()

const loading = ref(false)

const isLogged = computed(() => storeAuth.isLoggedIn)
const project = computed(() => storeGame.project)

onBeforeMount(async () => {
  loading.value = true

  await loadAllData()

  loading.value = false
})

const refreshJourneyAndProject = async () => {
  loading.value = true
  await storeGame.getVersion()
  await loadAllData()
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_base_loader = _resolveComponent("base-loader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_base_footer = _resolveComponent("base-footer")!
  const _component_base_locale_popup = _resolveComponent("base-locale-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_base_loader)
        ]))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_view, {
            class: "main",
            slot: "content"
          }),
          (_unref(isLogged))
            ? (_openBlock(), _createBlock(_component_base_footer, {
                key: 0,
                class: "footer",
                langs: _unref(project)?.langs
              }, null, 8, ["langs"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_base_locale_popup, {
      langs: _unref(project)?.langs,
      onUpdate: _cache[0] || (_cache[0] = ($event: any) => (refreshJourneyAndProject()))
    }, null, 8, ["langs"])
  ], 64))
}
}

})